module.exports = __webpack_public_path__ + "static/media/discount.02b4f966.png";